import contactCentre from './modules/contact-centre'
import extensions from './modules/extensions'

export default {
    contactCentre,
    extensions
}
